import React from "react";
import { Space } from "antd";
import { AxCalendar, AxDivider } from "@dynata/axiom3";

class Calendar extends React.Component {
  render() {
    return (
      <div className="section" id="calendar">
        <h3>Calendar</h3>
        <p>Container for displaying data in calendar form.</p>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`<AxCalendar/>`}</pre>
          <div className="prop-header">
            <p className="props-title">Props</p>
          </div>
          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>dateCellRender</td>
                <td>
                  Customize the display of the date cell, the returned content
                  will be appended to the cell
                </td>
                <td>function(date: Moment): ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>dateFullCellRender</td>
                <td>
                  Customize the display of the date cell, the returned content
                  will override the cell
                </td>
                <td>function(date: Moment): ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultValue</td>
                <td>The date selected by default</td>
                <td>
                  <a href="http://momentjs.com/">moment</a>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>disabledDate</td>
                <td>
                  Function that specifies the dates that cannot be selected,
                  <code>currentDate</code> is same moment object as
                  <code>value</code> prop which you shouldn't mutate it](
                  <a href="https://github.com/ant-design/ant-design/issues/30987">
                    https://github.com/ant-design/ant-design/issues/30987
                  </a>
                  )
                </td>
                <td>(currentDate: Moment) =&gt; boolean</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>fullscreen</td>
                <td>Whether to display in full-screen</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>headerRender</td>
                <td>Render custom header in panel</td>
                <td>
                  <pre>{`function(object:{value: Moment, type: string, onChange: f(),
        onTypeChange: f()})`}</pre>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>locale</td>
                <td>The calendar's locale</td>
                <td>object</td>
                <td>
                  <a href="https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json">
                    (default)
                  </a>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>mode</td>
                <td>The display mode of the calendar</td>
                <td>
                  <code>month</code> | <code>year</code>
                </td>
                <td>
                  <code>month</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>monthCellRender</td>
                <td>
                  Customize the display of the month cell, the returned content
                  will be appended to the cell
                </td>
                <td>function(date: Moment): ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>monthFullCellRender</td>
                <td>
                  Customize the display of the month cell, the returned content
                  will override the cell
                </td>
                <td>function(date: Moment): ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>validRange</td>
                <td>To set valid range</td>
                <td>
                  [<a href="http://momentjs.com/">moment</a>,
                  <a href="http://momentjs.com/">moment</a>]
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>value</td>
                <td>The current selected date</td>
                <td>
                  <a href="http://momentjs.com/">moment</a>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onChange</td>
                <td>Callback for when date changes</td>
                <td>function(date: Moment)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onPanelChange</td>
                <td>Callback for when panel changes</td>
                <td>function(date: Moment, mode: string)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onSelect</td>
                <td>Callback for when a date is selected</td>
                <td>function(date: Moment）</td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <AxDivider orientation="left" plain>
            Fullscreen: false
          </AxDivider>

          <div style={{ width: "400px" }}>
            <AxCalendar fullscreen={false} />
          </div>

          <AxDivider orientation="left" plain>
            Fullscreen
          </AxDivider>

          <AxCalendar />
        </Space>
      </div>
    );
  }
}
export default Calendar;
